// extracted by mini-css-extract-plugin
export default {"code_verification_prev":"PrevButton_code_verification_prev__7hOvI"};